'use strict';

/* globals $ */

var React = require('react');
var _ = require('lodash');

var Page = React.createClass({
    componentDidMount: function() {
        if (window.$) {
            $(this.refs.page).trigger('pageRendered', this.refs.page);
        }
        if (_.isFunction(this.props.executeAfterMount)) {
            this.props.executeAfterMount();
        }
    },

    renderItems: function() {
        var posts = [];
        var items = this.props.items;
        var item;

        for (var i = 0; i < items.length; i += 1) {
            item = items[i];
            item.pageIndex = this.props.pageIndex;
            if (item.klass) posts.push(React.createElement(item.klass, item));
            else console.warn('Skipping feed item without a class binded', item);
        }

        return posts;
    },

    render: function() {
        return (
            <div className="bastian-page" data-page-index={this.props.pageIndex} ref="page">
                {this.renderItems()}
            </div>
        );
    }
});

module.exports = Page;
